import React, { useState } from "react";
import "./style.css";
import Navbar from "../../Components/Navbar/index.tsx";
import cctv from "../../Assets/Services/cctv.jpeg";
import secuAbt from "../../Assets/Services/secuAbt.jpeg";
import techAbt from "../../Assets/Services/techAbt.png";
import emer from "../../Assets/Services/emer.jpeg";
import patrol from "../../Assets/Services/patrol.jpeg";
import covert from "../../Assets/Services/covert.jpeg";
import onsite from "../../Assets/Services/onsite.png";
import alpr from "../../Assets/Services/alpr.jpeg";
import vms from "../../Assets/Services/vms.png";
import all from "../../Assets/Services/all.jpeg";
import events from "../../Assets/Services/events.jpg";
import Footer from "../../Components/Footer/index.tsx";
import SecurityServicesCarousel from "../../Components/ServicesCarousel/index.tsx";
import { Helmet } from "react-helmet";

const services = {
  service1: {
    title: "Remote Surveillance / 24 Hour Command Centre",

    description: `Our cutting-edge 24-Hour Command Centre operates nonstop, 365 days a year, ensuring your assets and locations are always under watchful eyes. Manned by a dedicated team of highly trained controllers, the centre uses advanced surveillance systems to detect, assess, and respond to potential threats in real time.
    
    With seamless communication capabilities and fast coordination with on-ground teams or emergency services, we guarantee rapid intervention when it matters most. Whether it's a triggered alarm, unauthorized access, or suspicious activity, our team takes immediate action to secure your property and restore peace of mind.
    
    We don’t just monitor — we manage incidents proactively and professionally, so you're always protected, even when you're not on site.`,
    image: cctv,
  },

  service2: {
    title: "Provision of Qualified & Trained Security Personnel",
    description: `We provide professionally trained and qualified security personnel who are committed to maintaining the highest standards of safety and vigilance. Beyond their day-to-day responsibilities, our security team actively observes and identifies areas for improvement on-site.

Their valuable feedback on security-related matters allows us to offer clients actionable suggestions to enhance the overall safety and performance of their premises. This proactive and collaborative approach ensures a safer, more secure environment tailored to each client's unique needs.`,
    image: secuAbt,
  },
  service3: {
    title: "Technology Services",
    description: `We offer a comprehensive range of physical and technology-based security solutions, recognizing that traditional guarding methods alone are no longer sufficient in today’s evolving threat landscape. Our enhanced security model combines manpower with intelligent systems to deliver a more cost-effective, efficient, and proactive approach to safeguarding our clients’ premises.

Our technology offerings include advanced CCTV systems, automatic license plate recognition (ALPR), body-worn cameras, and other AI-powered tools — all designed to enhance situational awareness, improve response times, and reduce risk.`,
    image: techAbt,
  },
  service4: {
    title: "Emergency Response Team",
    description: `In response to the growing need for rapid and reliable support, especially during critical situations such as the COVID-19 pandemic, we have established a dedicated Emergency Response Team. This specialized unit is trained and equipped to respond swiftly to incidents on-site, ensuring safety, order, and business continuity at all times.

Our team remains on standby and ready to act — providing immediate assistance during emergencies and supporting clients with crisis management when it matters most.`,
    image: emer,
  },
  service5: {
    title: "Patrolling Officers",
    description: `Our dedicated Patrolling Officers conduct round-the-clock security checks across all assigned sites to ensure continuous vigilance and operational efficiency. Their primary role is to monitor and assess the performance and alertness of on-site security personnel, reinforcing accountability and discipline during duty hours.

Each patrol includes a detailed inspection and is followed by a comprehensive report documenting observations and any incidents, ensuring transparency and a proactive approach to site security.
`,
    image: patrol,
  },
  service6: {
    title: "Covert & Resilient Team",
    description: `Our Covert & Resilient Team is specially trained to carry out discreet operations aimed at identifying and mitigating potential risks and threats. Operating under strict confidentiality, they are capable of performing surveillance, intelligence gathering, and risk assessment without disrupting day-to-day activities on-site.

Their presence is strategic and low-profile, ensuring threats are detected and addressed before they escalate — enhancing overall site security with precision and discretion.`,
    image: covert,
  },
  service7: {
    title: "On Site Consultation",
    description: `Our team of dedicated security professionals provides on-site consultation services to help assess, enhance, and optimize the security measures at your premises. Through comprehensive site evaluations, we identify potential vulnerabilities and offer tailored recommendations to strengthen your overall security framework.

Whether it's improving access control, surveillance coverage, or emergency preparedness, our experts deliver practical, effective solutions based on your unique operational needs.`,
    image: onsite,
  },
  service8: {
    title: "Automatic License Plate Recognition (ALPR)",
    description: `Our Automatic License Plate Recognition (ALPR) system uses advanced artificial intelligence (AI) algorithms to detect and recognize vehicle license plates in real time. Designed for both security and operational efficiency, the ALPR system enables facility owners to automate access control by integrating with entry-point barriers, allowing or denying vehicle access without human intervention.

The system also provides real-time alerts for blacklisted vehicles, notifies on-duty security personnel, and monitors vehicle movement throughout the facility — including deliveries, visitor vehicles, maintenance teams, and more. With built-in tracking capabilities, the ALPR system can detect overstays and improve overall vehicle management at your site.`,
    image: alpr,
  },
  service9: {
    title: "Visitor Management System (VMS)",
    description: `Our Visitor Management System (VMS) provides a seamless and secure process for managing visitors, ensuring that every individual entering your premises is properly documented and monitored. With an emphasis on both security and efficiency, our VMS offers a reliable solution to track visitor entry, improve site safety, and maintain detailed records for auditing and compliance purposes.`,
    image: vms,
  },
  service10: {
    title: "Integrated Security Solutions Provider",
    description: `Visitor management is the process of tracking and recording the movement of individuals within a facility. By collecting and analyzing visitor data, a Visitor Management System (VMS) ensures that all visitors are registered, monitored, and documented for security and operational efficiency.

Our advanced VMS offers a digital solution for companies to securely manage and track guests entering their premises. This system not only streamlines visitor registration but also helps prevent security threats by requiring digital documentation of each visitor's information, including their entry, stay duration, and exit times.`,
    image: all,
  },
  service11: {
    title: "Events",
    description: `



    We proudly hosted a special event on the occasion of National Day, bringing together guests, community members, and dignitaries to celebrate the spirit of unity and patriotism. We were honored to welcome Mr. Desmond Tan Kok Ming, who has been serving as Senior Minister of State in the Prime Minister's Office, as our esteemed VIP guest.`,
    image: events,
  },
};

const ServicePage = () => {
  const [selectedService, setSelectedService] = useState(services.service1);
  const [animateImage, setAnimateImage] = useState(false);

  const handleServiceClick = (serviceKey) => {
    setAnimateImage(false); // Reset animation class
    setTimeout(() => {
      setSelectedService(services[serviceKey]);
      setAnimateImage(true); // Trigger animation after render
    }, 50); // Delay slightly to allow DOM to reset
  };

  return (
    <>
     
      <Helmet>
        <meta
          name="description"
          content="Explore the best security services in Singapore with Singapore Security Force. Ranked among the top 5 security companies, we offer expert services in executive protection, surveillance, and more."
        />
        <meta
          name="keywords"
          content="top security company Singapore, best security services Singapore, top 5 security companies, professional security services, trusted security solutions"
        />
        <title>Top & Trusted Security Company in Singapore| Singapore Security Force - Best Security Company</title>

        {/* Open Graph Tags for Social Sharing */}
        <meta property="og:title" content="Top Security Services | Singapore Security Force" />
        <meta
          property="og:description"
          content="Looking for the best security services in Singapore? Singapore Security Force ranks among the top 10 security companies. Learn more about our high-quality, professional security solutions."
        />
        <meta property="og:image" content="URL-to-your-image.jpg" />
        <meta property="og:url" content="https://singaporesecurityforce.com/services" />
        <meta property="og:type" content="website" />
        </Helmet>
       <Navbar />
    
      <div className="container-services py-5">

        
              
            
        {/* Left-side Service List */}
        <div className="">
          <div className="d-flex align-items-center mb-5">
            <h3 className="ser-our">Our</h3>
            <h2 className="mx-3 ser-hea">Services</h2>
          </div>

          <ul className="service-list-container">
            {Object.keys(services).map((serviceKey) => (
              <li
                key={serviceKey}
                className={`service-item ${
                  selectedService &&
                  selectedService.title === services[serviceKey].title
                    ? "service-item-active"
                    : ""
                }`}
                onClick={() => handleServiceClick(serviceKey)}
              >
                {services[serviceKey].title}
              </li>
            ))}
          </ul>
        </div>

        {/* Right-side Content Area */}
        <div className="serviceContent ">
          {selectedService ? (
            <div id="">
              <h4>{selectedService.title}</h4>
              <img
                src={selectedService.image}
                alt={selectedService.title}
                className={`img-fluid mt-3 centered-img ${
                  animateImage ? "animate-in" : ""
                }`}
              />
              <p className="service-desc">{selectedService.description}</p>
            </div>
          ) : (
            <p>Please select a service from the left.</p>
          )}
        </div>
      </div>
      <SecurityServicesCarousel />
      <Footer/>
    </>
  );
};

export default ServicePage;
